var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AdminLayout',[_c('ForgotPasswordForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }